module.exports = __webpack_public_path__ + "img/represa3d.404214d3.jpg";